import React, {useState} from "react"
import {Link} from "react-router-dom"
import {useForm} from "react-hook-form"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Button, ButtonGroup, useToast} from "@chakra-ui/react"
import {ArrowRightIcon, HomeIcon} from "@heroicons/react/24/outline"

import {Card} from "@components/display"
import {FTextArea} from "@components/form"
import {gamePlayApiCalls} from "../service"


type EndGamePanelProps = {
    cardTitle: string
    title: string
    subTitle?: string
    gamePlayId?: string
    questionId?: string
    onContinue?: () => void
}

export function EndGamePanel({cardTitle, title, subTitle, gamePlayId, questionId, onContinue}: EndGamePanelProps) {
    const toast = useToast()
    const [isFeedbackSent, setIsFeedbackSent] = useState<boolean>(false)

    const {
        handleSubmit,
        register,
        formState: {
            errors,
            isSubmitting
        }
    } = useForm({})

    async function onSubmit({message}) {

        if (!message || !gamePlayId || !questionId)
            return false

        try {
            await gamePlayApiCalls.saveFeedback(gamePlayId, questionId, message)

            toast({
                title: "Thank You for Your Feedback!",
                status: "success",
                duration: 2000,
                isClosable: true,
            })

            setIsFeedbackSent(true)

        } catch (err) {

        }


    }

    return <Card title={cardTitle}>
        <div className="text-center flex flex-col justify-center items-center space-y-4">
            <div className="grid grid-cols-3">
                <div className="col-span-1 flex items-center">
                    {isFeedbackSent ? <div>Thank You for Your Feedback!</div> :
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <FTextArea register={register} errors={errors} field="message"
                                       label="Please share about why you rated the Answers the way you did. (Optional)"/>
                            <Button isLoading={isSubmitting} onClick={handleSubmit(onSubmit)} type="submit" mt={6}
                                    w="full"
                                    variant="outline"
                                    colorScheme="blue">Submit
                                Feedback</Button>
                        </form>}
                </div>
                <div className="col-span-2 space-y-6">
                    <FontAwesomeIcon icon={["fal", "badge-check"]} size="4x"/>
                    <div>
                        <h3 className=" text-sm font-semibold text-gray-900">{title}</h3>
                        {subTitle &&
                          <p className=" text-sm text-gray-500">{subTitle}</p>}
                    </div>
                    <ButtonGroup>
                        <Button leftIcon={<HomeIcon className="w-4 h-4"/>} as={Link} to={"/"}>Go Home</Button>
                        {onContinue &&
                          <Button onClick={onContinue} rightIcon={<ArrowRightIcon className="w-4 h-4"/>}
                                  colorScheme="blue">Next Question</Button>}
                    </ButtonGroup>
                </div>

            </div>
        </div>
    </Card>
}